import {
  Verification,
  getVerifications,
} from 'modules/host-profile/clients/VerificationClient';
import { useEffect, useState } from 'react';
import { STATUS_INITIAL, STATUS_PENDING, STATUS_SUCCESS } from '~/constants';
import useAccount from '~/context/AuthContext/useAccount';

function useVerifications() {
  const { account } = useAccount();
  const [verifications, setVerifications] = useState<Verification[]>([]);
  const [status, setStatus] = useState(STATUS_INITIAL);

  useEffect(() => {
    if (account) {
      setStatus(STATUS_PENDING);
      getVerifications(account.id).then((response) => {
        setVerifications(response);
        setStatus(STATUS_SUCCESS);
      });
    }
  }, [account]);

  return { verifications, status };
}

export default useVerifications;
